import Link from 'next/link'
import { Eyebrow } from './Eyebrow'

interface PageHeaderProps {
  eyebrow?: string
  title: string
  subtitle?: string
  /** the single gold signature action for the screen */
  actionLabel?: string
  actionHref?: string
  /** secondary controls rendered to the left of the action (e.g. a view toggle) */
  children?: React.ReactNode
}

/** Editorial screen header — eyebrow + big title + subhead, with one gold action. */
export function PageHeader({ eyebrow, title, subtitle, actionLabel, actionHref, children }: PageHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4 mb-7">
      <div className="min-w-0">
        {eyebrow && <Eyebrow className="mb-2">{eyebrow}</Eyebrow>}
        <h1 className="text-h1 font-extrabold text-text-primary">
          {title}
        </h1>
        {subtitle && <p className="text-[14px] text-text-muted mt-1.5">{subtitle}</p>}
      </div>
      {(children || (actionLabel && actionHref)) && (
        <div className="flex items-center gap-2 flex-shrink-0">
          {children}
          {actionLabel && actionHref && (
            <Link
              href={actionHref}
              className="inline-flex items-center justify-center whitespace-nowrap font-bold rounded-lg px-5 py-2.5 text-[14px] bg-brand-primary text-black hover:bg-brand-primary-hover focus:outline-none focus:ring-2 focus:ring-brand-primary focus:ring-offset-2 transition-colors"
            >
              {actionLabel}
            </Link>
          )}
        </div>
      )}
    </div>
  )
}
